import * as blueprint from '@adc/blueprint'
import { gql } from '@adc/sdk'

export const GRAPH_USER_DETAILS = gql`
query resiPdp_currentUser($shouldFetchAdaptiveNav: Boolean!) {
  current_user {
    user_id
    party_id
    bidder_number
    email
    first_name
    last_name
    party {
      phones {
        number
        verified
        opt_in
      }
    }
    associated_user_documents {
      record_status_code
      user_document_id
      document_purpose_code
      urn
    }
    status
    is_current_user_remote_bid_qualified
    bidder_signature {
      __typename
      ... on OnlineBidderSignature {
        current {
          auction_registration_count
        }
      }
    }  
    purchase_profiles(filters:{ productTypes: [REO, DAY_1_REO] }) {
      ... on ReoPurchaseProfile {
        offer_template_id
        template_name
        percent_complete
      }
    }
    ${blueprint.user.fragments.buyingPreferences.reference}
    ${blueprint.user.fragments.adaptiveNavigation.reference} @include(if: $shouldFetchAdaptiveNav)
  }
}
${blueprint.user.fragments.buyingPreferenceFields.definition}
${blueprint.user.fragments.buyingPreferences.definition}
${blueprint.user.fragments.adaptiveNavigation.definition}
`
